module.exports = __webpack_public_path__ + "img/news-grey.228acb9.svg";